<template>
  <div id="tabContainer">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div v-show="isEdit">
          <el-button no="1" type="primary" :disabled="selectedContainerUsage === null" @click="changeSealHandler">
            {{ $t('SeaExport.SealNoChangeAdfterInspection') }}
          </el-button>
          <el-button no="2" type="primary" @click="autoLoadHandler">{{ $t('SeaExport.AutoAllocation') }}</el-button>
          <el-button type="primary" @click="autoLoadContractHandler">{{ $t('SeaExport.AutoAllocationContract') }}</el-button>
          <el-button no="3" type="primary" :disabled="selectedContainerUsage === null" @click="autoUnloadHandler">
            {{ $t('SeaExport.CleanOutTheLoadingRecord') }}
          </el-button>
          <el-button
            v-if="!job.lclMasterUuid"
            no="4"
            type="danger"
            :disabled="selectedContainerUsage === null"
            @click="deleteContainerHandler"
          >{{ $t('SeaExport.DeleteTheLoadingRecord') }}
          </el-button>
          <el-button v-if="isFCL" no="5" type="primary" @click="downTemplateBtn_clickHandler">
            {{ $t('SeaExport.TemplateDownload') }}
          </el-button>
          <el-upload
            action="string"
            :http-request="importExcelEventHandler"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUploadUsage"
            style="display: inline-block;padding-left: 5px;"
          >
            <el-button v-if="isFCL" v-show="isEdit" type="primary">{{ $t('SeaExport.ExcelImport') }}</el-button>
            <el-button v-if="toExoSystemJYD && job.masterFlag" :disabled="!(!jydEnable && !isEdit && job.jobState === 0)" no="canPushPreConfiguration" type="primary" @click="toCanPushPreConfiguration">{{ $t('SystemMaintenance.canPushPreConfiguration') }}</el-button>
          </el-upload>
        </div>
        <div>
          <span>
            {{ $t('SeaExport.CargoQuantityDescription') }}：{{ lbTotalDesc.lblContainerDesc }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotalDesc.lbTotalQuantity }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalWeight') }}：{{ lbTotalDesc.lbTotalWeight }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalCubage') }}：{{ lbTotalDesc.lbTotalCubage }}&nbsp;&nbsp;&nbsp;
            <el-button
              v-show="btnshowAWindow && !isEdit"
              no="6"
              type="primary"
              class="can-operate"
              @click="showAWindowClickHandler"
            >{{ $t('SeaExport.ViewAssociatedBusiness') }}</el-button>
          </span>
        </div>
      </div>
    </div>
    <div class="section" style="flex: 1">
      <cargo-ag-grid
        config-module="130115"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="containerUsages"
        :wrap-text="true"
        style="width:100%;height:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainerUsage"
      @sealCloseHandler="sealCloseHandler"
    />

    <!-- 查看关联业务 -->
    <associated-business-dialog
      :visible.sync="associatedBusinessDialog.visible"
      :a-data="associatedBusinessDialog.aData"
      :job="job"
      @refresh="refresh"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'

import { Job } from '@/class/model/booking/Job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import SealNumberChangeDialog from '@/components/Cargo/Job/sealNumberChangeDialog'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import ContainerNoHelper from '@/utils/containerNoHelper'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import StrUtils from '@/utils/StrUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { TabError } from '@/utils/class/TabError'
import { sortByMultiField } from '@/utils'
import AssociatedBusinessDialog from '@/components/Cargo/Job/associatedBusinessDialog'
import { queryAssociatedBusiness } from '@/api/seaExport/containerUsage'
import { importExcelData } from '@/api/seaExport/containerUsage'
import lodash from 'lodash'
import { formatNumberToThousands } from '@/utils'
import { roundHalfUp } from '@/utils/NumberUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { jydSendJobInfo } from '@/api/seaExport/seaCargoDoc'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { SHOW_BILLING_CACHE_KEY } from '@/components/Cargo/Job/booking/tabs/internalBillInfoBase'

export default {
  name: 'TabBuyerConsoleFclContainer',
  components: { AssociatedBusinessDialog, SealNumberChangeDialog },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonTextareaEditor,
          CargoAgGridCommonInputEditor
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.itemClickHandler,
        onRowDragEnd: this.onRowDragEnd
      },
      gridApi: null,
      boxNoDialog: {
        visible: false
      },
      associatedBusinessDialog: {
        visible: false,
        aData: {}
      },
      lbTotalDesc: { // 货物描述
        lblContainerDesc: '',
        lbTotalQuantity: '',
        lbTotalWeight: '',
        lbTotalCubage: ''
      },
      job: new Job().fillDefaultValue().getData(),
      containerUsages: [], // 装箱列表数据List
      dgContainerEditable: false, // 列表是否允许编辑
      selectedContainerUsage: null,
      isFCL: false, //  是否为整箱
      btnshowAWindow: false,
      toExoSystemJYD: false,
      jydEnable: false,
      isUpdateCargoDoc: false, // 修改了件毛体则为true,作用是同步了件毛体信息需要参与入库修改
      isTabBasic: true, // CARGO-7908 (cargo 中在bookingworkspace 中设置的是true)
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    user() {
      return this.context.user || {}
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.job.uuid)
    },
    columnDefs() {
      const defs =
        [
          {
            headerName: '',
            colId: 'serialNo',
            field: '',
            width: 60,
            rowDrag: this.dgContainerEditable && this.isEdit,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            lockVisible: true,
            wrapText: false // 去除因拖拽而导致的行自动撑高
          },
          {
            headerName: this.$t('SeaExport.ContainerSize'),
            colId: 'eqSize',
            field: 'eqSize',
            width: 100,
            cellStyle: (params) => {
              return ContainerUtil.containerPushDataStyleFunction2(params, 'eqSize')
            },
            valueFormatter: (params) => {
              return this.subClassLabelFunction(params.data, 'eqSize')
            }
          },
          {
            // 码头配载
            headerName: this.$t('SeaExport.WharfStowage'),
            colId: 'wharfStowage',
            field: 'wharfStowage',
            valueFormatter: (params) => {
              if (params.data.wharfStowage) {
                return params.data.wharfStowageState ? `${params.data.wharfStowageState}(${params.data.wharfStowage})` : params.data.wharfStowage
              } else {
                return params.data.wharfStowageState ? params.data.wharfStowageState : ''
              }
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerType'),
            colId: 'eqType',
            field: 'eqType',
            width: 100,
            cellStyle: (params) => {
              return ContainerUtil.containerPushDataStyleFunction2(params, 'eqType')
            },
            valueFormatter: (params) => {
              return this.subClassLabelFunction(params.data, 'eqType')
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerNo'),
            colId: 'containerNo',
            field: 'containerNo',
            width: 100,
            cellStyle: (params) => {
              return this.containerNbrStyleFunction(params)
            },
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: true,
              isTrim: true,
              multiplePaste: { isUppercase: true, isTrim: true }
            },
            onCellValueChanged: p => {
              const { newValue, oldValue, node, colDef } = p
              if (newValue && newValue.length > 11) {
                this.$message.warning(this.$t('SeaExport.ContainerNoOutOfRange'))
                node.setDataValue(colDef.colId, oldValue)
                return
              }
              this.onCellChange(p)
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerWeight'),
            colId: 'containerWeight',
            field: 'containerWeight',
            width: 100,
            cellStyle: (params) => {
              return ContainerUtil.containerPushDataStyleFunction2(params, 'containerWeight')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.SealNo'),
            colId: 'sealNo',
            field: 'sealNo',
            width: 100,
            cellStyle: (params) => {
              return this.sealNoStyleFunction(params)
            },
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isUppercase: true,
              isTrim: true,
              multiplePaste: { isUppercase: true, isTrim: true }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            cellStyle: (params) => {
              return ContainerUtil.containerPushDataStyleFunction2(params, 'quantity')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
            editable: this.dgContainerEditable && this.isEdit && this.isJydEditJobFields,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0
              },
              multiplePaste: { isNumber: true, precision: 0 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.GrossWeight'),
            colId: 'weight',
            field: 'weight',
            width: 100,
            cellStyle: (params) => {
              return ContainerUtil.containerPushDataStyleFunction2(params, 'weight')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit && this.isJydEditJobFields,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            cellStyle: (params) => {
              return ContainerUtil.containerPushDataStyleFunction2(params, 'cubage')
            },
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit && this.isJydEditJobFields,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
            colId: 'cargoName',
            field: 'cargoName',
            width: 120,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Marks'),
            colId: 'mark',
            field: 'mark',
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            cellEditorParams: {
              autoUppercase: this.isUppercaseByConfig
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Soc'),
            colId: 'soc',
            field: 'soc',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: this.dgContainerEditable && this.isEdit,
              tag: 'el-checkbox',
              valueChanged: p => {
                this.onCellChange(p)
              }
            }
          },
          {
            headerName: this.$t('SeaExport.Inspection'),
            colId: 'inSpected',
            field: 'inSpected',
            width: 100,
            valueFormatter: (params) => {
              return this.subInSpectedLabelFunc(params.data)
            }
          },
          {
            headerName: 'HSCODE',
            colId: 'hsCode',
            field: 'hsCode',
            width: 120,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              field: 'hsCode',
              multiplePaste: {}
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.ApproachDate'),
            colId: 'approachDate',
            field: 'approachDate',
            width: 120,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.PlayDate'),
            colId: 'playDate',
            field: 'playDate',
            width: 120,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.LoadingPort'),
            colId: 'loadingPort',
            field: 'loadingPort',
            hide: true,
            width: 100
          },
          {
            headerName: this.$t('SeaExport.PortOfDestination'),
            colId: 'destinationPort',
            field: 'destinationPort',
            hide: true,
            width: 100
          },
          {
            headerName: this.$t('SeaExport.TheArrivalOfPacketsSent'),
            colId: 'transportMessageDate',
            field: 'transportMessageDate',
            hide: true,
            width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CustomsClearanceInfo'),
            colId: 'customReleaseDate',
            field: 'customReleaseDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              if (params.data.customReleaseState) {
                return params.data.customReleaseState === 'Y' ? `${params.data.customReleaseState}(${params.data.customReleaseDate})` : params.data.customReleaseState
              } else {
                return params.data.customReleaseDate
              }
            }
          },
          {
            headerName: this.$t('SeaExport.WharfReleaseInfo'),
            colId: 'wharfReleaseDate',
            field: 'wharfReleaseDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              if (params.data.wharfReleaseDate) {
                return params.data.wharfReleaseState ? `${params.data.wharfReleaseState}(${params.data.wharfReleaseDate})` : params.data.wharfReleaseDate
              } else {
                return params.data.wharfReleaseState ? params.data.wharfReleaseState : ''
              }
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerAscription'),
            colId: 'containerAscription',
            field: 'containerAscription',
            width: 120,
            valueFormatter: (params) => {
              const options = [...SeaExportConstants.CONTAINER_ASCRIPTION_TYPE]
              const curOption = options.find(option => option.code === params.value)
              if (curOption) {
                return curOption.chineseName
              }
              return ''
            },
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                staticOptions: [...SeaExportConstants.CONTAINER_ASCRIPTION_TYPE],
                tagValue: 'code',
                tagName: 'chineseName'
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.PlateNumber'),
            colId: 'plateNumber',
            field: 'plateNumber',
            hide: true,
            width: 120
          },
          {
            headerName: this.$t('SeaExport.plateApproachDate'),
            colId: 'plateApproachDate',
            field: 'plateApproachDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.platePlayDate'),
            colId: 'platePlayDate',
            field: 'platePlayDate',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.Remarks'),
            colId: 'remark',
            field: 'remark',
            width: 100,
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AuthorizedQuantity'),
            colId: 'quantityContract',
            field: 'quantityContract',
            width: 100,
            hide: true,
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0
              },
              multiplePaste: { isNumber: true, precision: 0 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CommissionedGrossWeight'),
            colId: 'weightContract',
            field: 'weightContract',
            width: 100,
            hide: true,
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AuthorizedCubage'),
            colId: 'cubageContract',
            field: 'cubageContract',
            width: 100,
            hide: true,
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.dgContainerEditable && this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              },
              multiplePaste: { isNumber: true, precision: 3 }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.ContainerId'),
            field: 'containerId',
            hide: true,
            width: 80
          },
          {
            headerName: this.$t('SeaExport.ContainerSeqNo'),
            field: 'containerSeqNo',
            hide: true,
            width: 80
          }
        ]
      return defs
    },
    config() {
      return this.context.config
    }
  },
  watch: {},
  created() {
    // this.context.loading = true
    // await this.context.prepareData()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
      this.toExoSystemJYD = this.context.config.get('ToExoSystem') === 'JYD'
      let usageDirty = false
      if (row.containerUsages && row.containerUsages.length > 0) {
        for (const usage of row.containerUsages) {
          if (usage.hasOwnProperty('isDirty') && usage.isDirty) {
            usageDirty = usage.isDirty
            break
          }
        }
      }
      if (!isRefresh && !usageDirty) {
        this.clearContainer(row)
        return
      }

      this.job = row
      const jydEnable = LocalStorageUtils.getConfiguration(this.job.jobNo + '-msdSendApi')
      if (jydEnable) {
        this.jydEnable = jydEnable
      }
      this.jobChanged()
      this.btnshowAWindow = (StrUtils.isEmpty(this.job.relatedJob) && !StrUtils.isEmpty(this.job.trustFromJob)) ||
        (StrUtils.isEmpty(this.job.trustFromJob) && !StrUtils.isEmpty(this.job.relatedJob))
    },
    endTabHandler() {
      this.fillModel()
    },
    async jobChanged() {
      if (!this.job) return

      const job = new SeaExportJob(this.job)
      await Promise.all([
        job.getLclMaster(),
        job.getSeaEQ(),
        job.getCargoDoc(),
        job.getContainerUsages(),
        job.getContainers()
      ])

      await this.jobLoadResultHandler()

      // lcl 小票 通过 usage 关联出container
      if (job.lclMasterUuid) {
        const ctnr = []
        for (const item of job.containerUsages) {
          ctnr.push(item.container)
        }
        if (!job.containers) {
          job.containers = []
        }
        job.containers.splice(0, job.containers.length, ...ctnr)
      }

      // 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
      await ContainerUtil.buildContainerUsages(this.job)

      const containerUsages = this.job.containerUsages.sort((a, b) => {
        return a.serialNo - b.serialNo
      })
      containerUsages.forEach((item, index) => {
        item.serialNo = index
        item.customReleaseState = item.container.customReleaseState
        item.wharfReleaseState = item.container.wharfReleaseState
        item.wharfStowageState = item.container.wharfStowageState
      })
      this.containerUsages = containerUsages

      this.refreshContainerWeight()
      this.refreshTotal()

      if (this.job.lob === 'SE') {
        this.isFCL = this.job.containerLoadType === 'FCL'
      }
      // CARGO-10331 【提单制作】参数HBLZBPrintLockTab未生效，HBL已锁定仍能编辑
      this.dgContainerEditable = this.isEdit && StrUtils.isEmpty(this.job.lclMasterUuid)
    },

    getSubmitData() {
      this.validate()
      this.fillModel()

      const cargoDocKeySet = new Set()
      if (this.job.seaCargoDoc) {
        for (const cargoDoc of this.job.seaCargoDoc) {
          cargoDocKeySet.add(cargoDoc.uuid)
        }
      }
      // 装箱件毛体 可能是从基本页签同步而来 没有触发cellChange 方法，同步箱子上的件毛体
      for (const usage of this.containerUsages) {
        if (usage.container) {
          usage.container.quantity = usage.quantity
          usage.container.weight = usage.weight
          usage.container.cubage = usage.cubage
          let updateEdiContainer = false
          if (this.job.uuid && usage.ediContainers && usage.ediContainers.length > 0) {
            for (const ediContainer of usage.ediContainers) {
              if (!cargoDocKeySet.has(ediContainer.cargoDocUuid) && (ediContainer.containerNo !== usage.container.containerNo || ediContainer.sealNo !== usage.container.sealNo)) {
                ediContainer.containerNo = usage.container.containerNo
                ediContainer.sealNo = usage.container.sealNo
                updateEdiContainer = true
              }
            }
          }
          if (!updateEdiContainer) {
            delete usage.ediContainers
          }
        }
      }
      const job = { ...this.job }
      const result = {
        job, // 未打开过时 件毛体同步数据需要保存
        containers: this.job.containers.filter(p => p.isDirty === true),
        delContainerUuids: this.job.delContainerUuids, // 删除的箱子uuid
        containerNums: this.containerUsages?.length || 0
      }
      // 修改件毛体
      if (this.isUpdateCargoDoc) {
        result.seaCargoDoc = [...job.seaCargoDoc]
      }
      return result
    },
    fillModel() {
      // CARGO-7908
      const expression = Number(this.config.get('ContainerUpdateJobQCW'))
      if (expression === 3 && this.isTabBasic) {
        ContainerUtil.refContainerUsageQwc(this.job, 3)
      }
    },
    /**
     * 验证
     */
    validate() {
      if (!this.job || !this.job.containerUsages || !this.isEdit) {
        return true
      }
      const msg = ContainerUtil.validateContainerUsage(this.job)
      if (msg) {
        throw new TabError(msg, 'tabContainer')
      }
      return true
    },
    async jobLoadResultHandler() {
      // 根据箱型初始化箱子(待审核的时候不允许看到装箱信息)
      if (this.job.jobState > SystemConstants.PENDING) {
        await ContainerUtil.autoJustContainerUsages(this.job, this.action)
      }

      // 避免 JSON 对象的循环引用  sortByMultiField 报错 ，后端排序
      // this.job.containerUsages = this.sortByOrder(this.job.containerUsages)

      this.selectedContainerUsage = null

      //  需要先 关联 container 与 containerUsage之后 调用
      // await this.refreshContainerWeight()

      this.checkCargoDocState()
      // this.refreshTotal()
    },
    // 按照指定字段排序
    sortByOrder(categoryArray) {
      if (categoryArray == null || categoryArray.length === 0) {
        return null
      } else {
        categoryArray = sortByMultiField(categoryArray, ['dateCreated'], false)
      }
      return categoryArray
    },
    refreshContainerWeight() {
      for (const usage of this.containerUsages) {
        if (usage.container) {
          // 列显示 箱子相关信息 移至 usage
          const eqSize = EQSize.getEQSizeByCode(usage.container.eqSize)
          usage.eqSize = eqSize === null ? '' : eqSize.code
          usage.eqType = usage.container.eqType
          usage.containerNo = usage.container.containerNo
          usage.containerWeight = usage.container.containerWeight
          usage.sealNo = usage.container.sealNo
          usage.remark = usage.container.remark

          usage.approachDate = usage.container.approachDate
          usage.playDate = usage.container.playDate
          usage.loadingPort = usage.container.loadingPort
          usage.dischargingPort = usage.container.dischargingPort
          usage.destinationPort = usage.container.destinationPort
          usage.transportMessageDate = usage.container.transportMessageDate
          usage.wharfReleaseDate = usage.container.wharfReleaseDate
          usage.customReleaseDate = usage.container.customReleaseDate
          usage.containerAscription = usage.container.containerAscription
          usage.plateNumber = usage.container.plateNumber
          usage.plateApproachDate = usage.container.plateApproachDate
          usage.platePlayDate = usage.container.platePlayDate
        }
      }
    },
    checkCargoDocState() {
      if (this.isEdit) {
        let unlock = true
        for (const doc of this.job.cargoDoc) {
          if (doc.docType.substr(0, 3) === 'HBL' && doc.state > 1) {
            unlock = false
            break
          }
        }
        this.dgContainerEditable = unlock && StrUtils.isEmpty(this.job.lclMasterUuid)
      }
    },
    refreshTotal() {
      let quantity = 0
      let weight = 0
      let cubage = 0

      for (const usage of this.job.containerUsages) {
        quantity += usage.quantity
        if (!isNaN(usage.weight)) {
          weight += usage.weight
        }
        if (!isNaN(usage.cubage)) {
          cubage += usage.cubage
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
      this.lbTotalDesc.lblContainerDesc = ContainerUtil.getContainerDesc(this.job)
    },
    containerNbrStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage && !ContainerNoHelper.checkContainerNo(params.value)) {
          return { color: '#F56C6C' }
        }
        if (usage.container !== null && DataPushCompareUtils.comparePushData(this.$t('SeaExport.ContainerNo'), params.value, usage.container.uuid)) {
          return { color: '#1F75D5' }
        }
      }
      return { color: '' }
    },
    sealNoStyleFunction(params) {
      const usage = params.data
      if (usage.container) {
        if (usage.isReSealed) {
          return { color: '#F56C6C' }
        }
        if (usage.container != null && DataPushCompareUtils.comparePushData(this.$t('SeaExport.SealNo'), params.value, usage.container.uuid)) {
          return { color: '#1F75D5' }
        }
      }
      return { color: '' }
    },
    containerAscriptionFunc(val) {
      for (const item of SeaExportConstants.CONTAINER_ASCRIPTION_TYPE) {
        if (item.code === val) {
          return item.chineseName
        }
      }
    },
    subInSpectedLabelFunc(data) {
      if (data && data.container) {
        const isInSpected = data.container.inSpected
        return isInSpected ? this.$t('Message.Yes') : this.$t('Message.No')
      }
      return ''
    },
    subClassLabelFunction(data, fieldName) {
      if (fieldName === 'eqSize') {
        const eqSize = data.container ? EQSize.getEQSizeByCode(data.container[fieldName]) : null
        return eqSize === null ? '' : eqSize.name
      } else {
        if (!data.container) return ''
        return data.container[fieldName] || ''
      }
    },
    /**
     * 放行信息转换
     */
    releaseDateLabelFunc(data, fieldName) {
      if (data != null) {
        const value = data[fieldName]
        if (value != null) {
          return 'Y(' + ColumnUtils.dateLabelFunc(value) + ')'
        }
      }
      return 'N'
    },
    // 行选择事件
    itemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectedContainerUsage = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedContainerUsage = node.data
          }
        })
      }
    },
    // 列编辑修改事件 (gridEditSaveHandler)
    async onCellChange(params) {
      const _job = this.job
      const usage = params.data
      if (!usage) {
        return
      }
      // 列编辑时 usage.container 没了，所以加了如下方法重新赋值
      if (usage && !usage.container && this.job.containers && this.job.containers.length > 0) {
        for (const container of this.job.containers) {
          if (StrUtils.isEmpty(container.uuid)) continue
          if (usage.containerUuid === container.uuid) {
            usage.container = container
          }
          if (container.containerUsage) {
            for (let oldUsage of container.containerUsage) {
              if (usage.uuid === oldUsage.uuid) {
                oldUsage = usage
              }
            }
          }
        }
      }
      usage.container.isDirty = true
      const key = params.field || params.colDef.colId
      switch (key) {
        case 'containerNo':
          console.log('containerNo')
          usage.container.containerNo = usage.containerNo
          this.syncContainerSealNoForMbl2Hbl2(usage)
          break
        case 'sealNo':
          usage.container.sealNo = usage.sealNo
          this.syncContainerSealNoForMbl2Hbl2(usage)
          break
        case 'containerWeight':
          // 箱重处理四舍五入 入库（控件只做了前端显示处理）
          if (usage.containerWeight) {
            usage.containerWeight = roundHalfUp(usage.containerWeight, 3)
            usage.container.containerWeight = usage.containerWeight
          } else {
            usage.containerWeight = 0
            usage.container.containerWeight = usage.containerWeight
          }
          this.syncVgmInfo(usage.container)
          break
        case 'containerAscription':
          usage.container.containerAscription = usage.containerAscription
          break
        case 'cargoName':
          usage.container.cargoName = usage.cargoName
          break
        case 'remark':
          usage.container.remark = usage.remark
          break
        case 'mark':
          usage.container.mark = usage.mark
          break
        case 'quantity' :
          // 用删除的方式 内容是空 保存null 会报错
          if (!usage.quantity) {
            usage.quantity = 0
          }
          // h5 不需要 quantityChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.quantity = usage.quantity
            }
          }
          usage.isDirty = true
          break
        case 'weight' :
          if (!usage.weight) {
            usage.weight = 0
          }
          // h5 不需要  weightChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.weight = usage.weight
            }
          }
          this.syncVgmInfo(usage.container)
          break
        case 'cubage' :
          if (!usage.cubage) {
            usage.cubage = 0
          }
          // h5 不需要  cubageChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC()
            this.refreshQWC()
            if (usage.container) {
              usage.container.cubage = usage.cubage
            }
          }
          break
        case 'quantityContract' :
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.syncContractQuantityWeightCubageToJob('quantityContract', 'quantityActual')
          }
          break
        case 'weightContract' :
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.syncContractQuantityWeightCubageToJob('weightContract', 'weightActual')
          }
          break
        case 'cubageContract' :
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.syncContractQuantityWeightCubageToJob('cubageContract', 'cubageActual')
          }
          break
        default :
          break
      }
      // this.gridOptions.api.applyTransaction({ update: [usage] })
    },
    // 同步箱号到MBL拆并单、HBL拆并单
    async syncContainerSealNoForMbl2Hbl2(containerUsage) {
      let updatedEdiContainer = false
      const seaCargoDocs = await new SeaExportJob(this.job).getSeaCargoDoc()
      for (const cargoDoc of seaCargoDocs) {
        if (cargoDoc.docType !== CargoDocConsts.MBL2 && cargoDoc.docType !== CargoDocConsts.HBL2) {
          continue
        }
        await new SeaCargoDoc(cargoDoc).getEdiContainer()
        if (!cargoDoc.ediContainer || cargoDoc.ediContainer.length <= 0) {
          continue
        }
        for (const item of cargoDoc.ediContainer) {
          if (item.deleted) {
            continue
          }
          if (item.containerUsageUuid && item.containerUsageUuid === containerUsage.uuid) {
            item.containerNo = containerUsage.containerNo
            item.sealNo = containerUsage.sealNo
            updatedEdiContainer = true
          }
        }
      }
      if (updatedEdiContainer) {
        this.isUpdateCargoDoc = true
        this.$message.success(this.$t('Message.SyncContainerSealNoToBillOfLading'))
      } else {
        if (containerUsage.ediContainers && containerUsage.ediContainers.length > 0) {
          for (const ediContainer of containerUsage.ediContainers) {
            if (ediContainer.containerNo !== containerUsage.containerNo || ediContainer.sealNo !== containerUsage.sealNo) {
              this.$message.success(this.$t('Message.SyncContainerSealNoToBillOfLading'))
              break
            }
          }
        }
      }
    },
    syncContractQuantityWeightCubageToJob(contractField, actualField) {
      let num = 0
      for (const usage of this.containerUsages) {
        num += Number(usage[contractField]) || 0
      }
      if (num > 0) {
        this.job[contractField] = num
        const rule = Number(this.config.get('SEQuantityWeightCubageRule'))
        if (rule === 1 || rule === 2) {
          this.job[actualField] = num
        }
      }
    },
    // CARGO-8570 海出详情VGM页面，VGM重量自动计算
    syncVgmInfo(container) {
      ContainerUtil.refreshVgmWeight(container)
    },
    /**
     * 计算件毛体总数
     */
    refreshQWC() {
      let quantity = 0
      let weight = 0
      let cubage = 0
      for (const usage of this.job.containerUsages) {
        quantity += Number(usage.quantity) || 0
        if (!isNaN(usage.weight)) {
          weight += Number(usage.weight)
        }
        if (!isNaN(usage.cubage)) {
          cubage += Number(usage.cubage)
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
    },
    updateJobActualQWC() {
      this.isUpdateCargoDoc = true
      ContainerUtil.refContainerUsageQwc(this.job, 1)
    },
    // 查验更改封号
    changeSealHandler() {
      if (!this.selectedContainerUsage) {
        return
      }
      this.boxNoDialog.visible = true
    },
    // 查验更改封号 回调事件
    sealCloseHandler(data) {
      const usage = this.selectedContainerUsage
      if (usage.container.sealNo !== data.sealNo) {
        usage.isReSealed = true
        usage.container.inSpected = true
      }
      usage.container.sealNo = data.sealNo
      usage.container.containerNo = data.containerNo
      usage.container.remark = data.remark

      usage.container.isDirty = true

      // 箱子信息列字段移至 usage
      usage.sealNo = data.sealNo
      usage.containerNo = data.containerNo
      usage.remark = data.remark

      this.syncContainerSealNoForMbl2Hbl2(usage)

      this.gridApi.refreshCells({ force: true })
    },
    // 自动装箱
    autoLoadHandler() {
      ContainerUtil.autoLoadContainerUsage(this.job)
      // 设置更改标识
      for (const ctnr of this.job.containers) {
        ctnr.isDirty = true
      }
      this.gridApi.setRowData(this.job.containerUsages)
      this.refreshTotal()
    },
    // 自动装箱(委托)
    autoLoadContractHandler() {
      ContainerUtil.autoLoadContainerUsageContract(this.job)
      // 设置更改标识
      for (const ctnr of this.job.containers) {
        ctnr.isDirty = true
      }
      this.gridApi.setRowData(this.job.containerUsages)
    },
    // 清空装箱记录
    autoUnloadHandler() {
      const usage = this.selectedContainerUsage
      if (usage) {
        if (!this.checkRelatedEdiContainer([usage])) {
          return
        }
        usage.container.containerNo = ''
        usage.container.sealNo = ''
        usage.weight = 0
        usage.quantity = 0
        usage.cubage = 0
        usage.weightContract = 0
        usage.quantityContract = 0
        usage.cubageContract = 0
        usage.hsCode = ''
        usage.container.cargoName = ''
        usage.cargoName = ''

        // 箱子信息列字段移至 usage
        usage.containerNo = ''
        usage.sealNo = ''

        usage.container.isDirty = true
        usage.isDirty = true
      }
      this.gridOptions.api.applyTransaction({ update: [usage] })
      this.refreshTotal()
    },
    // 删除装箱记录
    deleteContainerHandler() {
      const items = this.gridApi.getSelectedRows()
      if (!this.checkRelatedEdiContainer(items)) {
        return
      }
      for (const usage of items) {
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (!StrUtils.isEmpty(usage.uuid)) {
          if (!this.job.delContainerUuids) {
            this.job.delContainerUuids = []
          }
          this.job.delContainerUuids.push(usage.containerUuid)
        }

        const index = this.containerUsages.findIndex(p => p === usage)
        this.containerUsages.splice(index, 1)
      }
      this.refreshTotal()
    },
    // 校验是否有关联的提单装箱信息
    checkRelatedEdiContainer(usages) {
      for (const usage of usages) {
        if (usage.ediContainers && usage.ediContainers.length > 0) {
          this.$message.warning(this.$t('Message.AssociatedBillOfLadingCannotDelete'))
          return false
        }
      }
      return true
    },
    // 查看关联业务
    showAWindowClickHandler() {
      if ((!this.job.relatedJob && this.job.trustFromJob) || this.job.relatedJob && !this.job.trustFromJob) {
        const params =
          {
            trustFromJobNo: this.job.trustFromJob,
            relatedJobNo: this.job.relatedJob
          }
        // 调用api
        queryAssociatedBusiness(params).then(res => {
          this.queryWindowResultHandler(res.data)
        })
      }
    },
    queryWindowResultHandler(data) {
      if (!data) return
      this.associatedBusinessDialog.aData = data
      this.associatedBusinessDialog.visible = true
    },
    // 刷新
    async refresh() {
      if (this.job && !StrUtils.isEmpty(this.job.uuid)) {
        const job = new SeaExportJob(this.job)
        job.seaEQ = ''
        job.containers = ''
        job.containerUsages = ''
        await Promise.all([
          job.getSeaEQ(),
          job.getContainerUsages(),
          job.getContainers()
        ])
        await this.jobChanged()
      }
    },
    // 模板下载
    downTemplateBtn_clickHandler() {
      const fileName = 'ContainerUsageImportTemplate.xls'
      const folderName = 'booking'
      ExportUtils.downloadTemplateFile(fileName, folderName)
    },
    beforeUploadUsage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // excel导入
    importExcelEventHandler(item) {
      const usages = lodash.cloneDeep(this.job.containerUsages)
      // 避免循环引用
      for (const usage of usages) {
        delete usage.container.containerUsage
      }

      const jobObj = { job: { lob: this.job.lob }, seaEQ: this.job.seaEQ, containerUsages: usages }
      const params = {
        file: item.file,
        job: JSON.stringify(jobObj),
        jobUuid: this.job.uuid,
        jobNo: this.job.jobNo
      }
      importExcelData(params).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.uploadSuccessUsage(response.data)
        }
      })
    },
    // excel导入 后数据处理 importFileHandler
    uploadSuccessUsage(data) {
      if (!data && !this.job) {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
        return
      }
      const usageCompare = []
      for (const usage of this.job.containerUsages) {
        const oldContainer = usage.container
        for (const newUsage of data.containerUsages) {
          // 记录 已匹配的数据 如已参与比较不再 比对
          if (usageCompare.findIndex(p => p === newUsage) > -1) {
            continue
          }
          const newContainer = newUsage.container
          if (oldContainer.eqSize === newContainer.eqSize && oldContainer.eqType === newContainer.eqType) {
            oldContainer.containerNo = newContainer.containerNo
            oldContainer.sealNo = newContainer.sealNo
            oldContainer.containerWeight = newContainer.containerWeight
            oldContainer.remark = newContainer.remark
            oldContainer.cargoName = newContainer.cargoName
            oldContainer.isDirty = true

            usage.containerNo = newContainer.containerNo
            usage.containerWeight = newContainer.containerWeight
            usage.sealNo = newContainer.sealNo
            usage.remark = newContainer.remark
            usage.containerWeight = newContainer.containerWeight
            usage.cargoName = newContainer.cargoName

            usage.quantity = newUsage.quantity
            usage.weight = newUsage.weight
            usage.cubage = newUsage.cubage
            usage.hsCode = newUsage.hsCode
            usage.soc = newUsage.soc
            usage.isDirty = true

            usageCompare.push(newUsage)

            break
          }
        }
      }
      this.refreshTotal()
      this.gridApi.refreshCells({ force: true })
    },
    // 组装打印参数
    getPrintData() {
      const containerUsages = this.gridApi.getSelectedRows()
      if (!containerUsages || containerUsages.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      const params = {}
      if (containerUsages.length === 1) {
        params.CONTAINER_UUID = containerUsages[0].container.uuid
        params.category = 'FCL'
        params.ctx = new SeaExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "FCL", params, this);
      } else {
        const uids = []
        for (const c of containerUsages) {
          if (c.container && c.container.uuid && !uids.includes(c.container.uuid)) {
            uids.push(c.container.uuid)
          }
        }
        params.CONTAINER_UUID = uids
        params.category = 'CONTAINER_LIST'
        params.ctx = new SeaExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "CONTAINER_LIST", params, this);
      }
      this.$logger.log('params', params)
      return params
    },
    onRowDragEnd(params) {
      console.log('dragEnd', params)
      params.api.getModel().rowsToDisplay.forEach(node => {
        console.log(node)
        node.data.serialNo = node.rowIndex
        this.onCellChange({ data: node.data, colDef: { colId: 'serialNo' }})
      })
    },
    async toCanPushPreConfiguration() {
      this.$confirm(this.$t('SystemMaintenance.pushMasterData'), this.$t('SystemMaintenance.pushPreConfiguredInformation'), {
        confirmButtonText: this.$t('Invoice.invoice_confirm'),
        cancelButtonText: this.$t('Message.Cancel'),
        type: 'info',
        closeOnClickModal: false
      }).then(async() => {
        this.loading = getLoading()
        await jydSendJobInfo({ jobUuidList: [this.job.uuid], canSubmitManifest: 1 }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SendSuccess'))
          this.jydEnable = true
          LocalStorageUtils.setConfiguration(this.job.jobNo + '-msdSendApi', true)
        }).catch(error => this.$message.error(error)).finally(() => this.loading.close())
      })
    },
    clearContainer(row) {
      ContainerUtil.clearContainer(row)
      if ((!row.seaEQ || row.seaEQ.length <= 0) && row.lob === 'SE' && row.containerLoadType === 'BCF') {
        this.containerUsages = []
      }
    }
  }
}
</script>
<style lang='scss'>
</style>
